export var singletons = {
    sockets: {},
    profile:null,
    cluster: {}
};